"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FullscreenLoader = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _reactPortal = require("react-portal");

var _emotionTheming = require("emotion-theming");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _ = _interopRequireDefault(require("./"));

var _Loader = require("./Loader.style");

var FullscreenLoader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FullscreenLoader, _React$Component);

  function FullscreenLoader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FullscreenLoader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FullscreenLoader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "shouldShow", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "showCount", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "showFullscreenLoader", function (show) {
      if (show) {
        _this.showCount = _this.showCount + 1;
      } else if (!show && _this.showCount > 0) {
        _this.showCount = _this.showCount - 1;
      }

      var shouldShow = _this.showCount > 0;

      if (_this.shouldShow !== shouldShow) {
        if (shouldShow) {
          document.body.appendChild(_this.popupNode);
        } // TODO: remove settimeout logic and implement proper one


        _this.shouldShow = shouldShow;
        setTimeout(function () {
          return _this.setState({}, function () {
            if (!shouldShow && !_this.shouldShow) {
              _this.popupNode.parentNode && _this.popupNode.parentNode.removeChild(_this.popupNode);
            }
          });
        }, 10);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(FullscreenLoader, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.popupNode = document.createElement('div');
      this.popupNode.style = 'position: absolute; top: 0px; left: 0px; right: 0; bottom: 0; z-index:1000;'; // document.body.appendChild(this.popupNode);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.popupNode.parentNode && this.popupNode.parentNode.removeChild(this.popupNode);
    }
  }, {
    key: "render",
    value: function render() {
      var shouldShow = this.shouldShow;

      if (!shouldShow) {
        return null;
      }

      return _react.default.createElement(_emotionTheming.ThemeProvider, {
        theme: _themeConfig.default
      }, _react.default.createElement(_reactPortal.Portal, {
        node: this.popupNode
      }, _react.default.createElement(_Loader.FullScreenWrapper, null, _react.default.createElement(_.default, {
        width: 60,
        height: 60
      }))));
    }
  }]);
  return FullscreenLoader;
}(_react.default.Component);

exports.FullscreenLoader = FullscreenLoader;
var el = document.createElement('div');
document.body.appendChild(el);

var _render = (0, _reactDom.render)(_react.default.createElement(FullscreenLoader, null), el),
    showFullscreenLoader = _render.showFullscreenLoader;

var _default = showFullscreenLoader;
exports.default = _default;
window.__showFullscreenLoader = showFullscreenLoader;